import { securedAxiosInstance } from "../axios";
import { toSnakeCase } from "@estaly/ui";

class StoresService {
  fetchIndex(params) {
    return securedAxiosInstance.get("/stores", { params: toSnakeCase(params) });
  }

  fetch(id, includes = []) {
    return securedAxiosInstance.get(`/stores/${id}`, { params: { includes } });
  }

  update(storeId, data) {
    return securedAxiosInstance.put(`/stores/${storeId}`, toSnakeCase(data));
  }

  exportXlsx() {
    return securedAxiosInstance.get("/stores/export", { responseType: "blob" });
  }

  updateSalesManager(storeId, insurerManagerId) {
    return securedAxiosInstance.put(`/stores/${storeId}/update_insurer_sales_manager`, {
      insurer_manager_id: insurerManagerId,
    });
  }
}

export default new StoresService();
